import { memo } from 'react';
import { Icon, Tooltip, TooltipProps } from '@mui/material';
import {
  AccountBox,
  AccountTreeOutlined,
  Add,
  AddCircleOutline,
  AlarmOutlined,
  Announcement,
  Apartment,
  AssignmentIndOutlined,
  AssignmentLateOutlined,
  AssignmentTurnedInOutlined,
  Business,
  CallMade,
  CallReceived,
  ChatOutlined,
  CheckCircleOutlineOutlined,
  CheckOutlined,
  CleaningServices,
  Clear,
  Close,
  Comment,
  CommentOutlined,
  ConfirmationNumberOutlined,
  ContactMailOutlined,
  ContentCopy,
  CreditCard,
  CreditScore,
  DeleteOutline,
  DoDisturb,
  DoNotDisturbOutlined,
  EditOutlined,
  ElectricBolt,
  ElectricMeterOutlined,
  EmojiFlags,
  EnhancedEncryptionOutlined,
  Event,
  EventAvailableOutlined,
  EventNoteOutlined,
  FastForward,
  FastRewind,
  FileDownload,
  FileOpenOutlined,
  FileUpload,
  FindInPageOutlined,
  ForwardToInboxOutlined,
  GroupAddOutlined,
  GroupOutlined,
  HeadsetMicOutlined,
  HideSourceOutlined,
  HomeOutlined,
  HourglassBottomOutlined,
  Info,
  KeyboardArrowDownOutlined,
  KeyboardArrowUpOutlined,
  Language,
  LeakAddOutlined,
  LocalAtm,
  LocalFireDepartment,
  LocalFireDepartmentOutlined,
  LocalLaundryServiceOutlined,
  LocalOfferOutlined,
  LockOpenOutlined,
  LockOutlined,
  LoginOutlined,
  MailOutline,
  MapsHomeWorkOutlined,
  MoreVert,
  MoveToInboxOutlined,
  NoteAddOutlined,
  PauseCircleOutlineOutlined,
  PersonAddAlt1Outlined,
  Phone,
  PhoneCallbackOutlined,
  PhoneForwardedOutlined,
  PhoneOutlined,
  PlayArrowOutlined,
  PlaylistAddOutlined,
  PowerOutlined,
  PushPinOutlined,
  RadioButtonUnchecked,
  RefreshOutlined,
  Remove,
  RemoveDoneOutlined,
  ReportProblemOutlined,
  RotateLeft,
  SearchOutlined,
  Security,
  SellOutlined,
  SendOutlined,
  SettingsBackupRestoreRounded,
  SkipNext,
  SkipPrevious,
  SnoozeOutlined,
  StarBorderOutlined,
  StarOutlined,
  StarHalf,
  Sync,
  SyncAlt,
  SyncOutlined,
  Tag,
  TextsmsOutlined,
  TuneOutlined,
  Tv,
  ViewColumn,
  Visibility,
  VisibilityOff,
  VolumeOffOutlined,
  VolunteerActivismOutlined,
  WarningAmberOutlined,
  WaterDrop,
  Wifi,
  YoutubeSearchedForOutlined,
  ZoomInMap,
  ZoomOutMap,
  ThumbUp,
  RequestQuoteOutlined,
  ElectricalServicesOutlined,
  HolidayVillageOutlined,
  ReplayOutlined,
  TimerOutlined,
  SupportAgentOutlined,
  HelpOutlineOutlined,
  DoneOutlined,
  PlayArrow,
  ErrorOutline,
  DownloadingOutlined,
} from '@mui/icons-material';

export type IconName = keyof typeof allIcons;

interface Props {
  name: IconName;
  pointer?: boolean;
  fontSize?: 'inherit' | 'large' | 'medium' | 'small';
  tooltip?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  color?: string;
  classname?: string;
  rounded?: boolean;
  tooltipOptions?: Partial<TooltipProps>;
  sx?: any;
}

const allIcons = {
  email: MailOutline,
  phone: Phone,
  phoneOutlined: PhoneOutlined,
  business: Business,
  user: AccountBox,
  calendar: Event,
  money: LocalAtm,
  checkedCircle: CheckCircleOutlineOutlined,
  unChecked: RadioButtonUnchecked,
  check: CheckOutlined,
  completed: CheckCircleOutlineOutlined,
  unCompleted: HideSourceOutlined,
  fullStar: StarOutlined,
  emptyStar: StarBorderOutlined,
  starHalf: StarHalf,
  edit: EditOutlined,
  delete: DeleteOutline,
  addCircleOut: AddCircleOutline,
  add: Add,
  sales: SellOutlined,
  dwelling: MapsHomeWorkOutlined,
  source: MoveToInboxOutlined,
  moveIn: LoginOutlined,
  home: HomeOutlined,
  arrowDown: KeyboardArrowDownOutlined,
  arrowUp: KeyboardArrowUpOutlined,
  doDisturb: DoDisturb,
  emojiFlags: EmojiFlags,
  fileDownload: FileDownload,
  fileUpload: FileUpload,
  moreVert: MoreVert,
  canceled: DoNotDisturbOutlined,
  cancelled: DoNotDisturbOutlined,
  leads: SearchOutlined,
  processing: PlayArrowOutlined,
  note: EventNoteOutlined,
  sms: TextsmsOutlined,
  phoneCall: PhoneForwardedOutlined,
  claimLead: GroupOutlined,
  insurance: VolunteerActivismOutlined,
  vault: EnhancedEncryptionOutlined,
  alertAffiliate: AssignmentLateOutlined,
  inviteAffilate: GroupAddOutlined,
  clock: AlarmOutlined,
  ticket: ConfirmationNumberOutlined,
  documentAdd: NoteAddOutlined,
  documentFind: FindInPageOutlined,
  personAdd: PersonAddAlt1Outlined,
  hourglass: HourglassBottomOutlined,
  hold: HourglassBottomOutlined,
  snooze: SnoozeOutlined,
  pause: PauseCircleOutlineOutlined,
  pending: PauseCircleOutlineOutlined,
  reportProblem: ReportProblemOutlined,
  'action required': ReportProblemOutlined,
  syncOutlined: SyncOutlined,
  'active service': SyncOutlined,
  lock: LockOutlined,
  lockOpen: LockOpenOutlined,
  eventAvailableOutlined: EventAvailableOutlined,
  leakAddOutlined: LeakAddOutlined,
  mute: VolumeOffOutlined,
  sendOutlined: SendOutlined,
  setTags: LocalOfferOutlined,
  setStatus: PlaylistAddOutlined,
  language: Language,
  info: Info,
  apartment: Apartment,
  assignment: AssignmentIndOutlined,
  assignmentTurnedIn: AssignmentTurnedInOutlined,
  house: HomeOutlined,
  announcement: Announcement,
  archived: RemoveDoneOutlined,
  power: PowerOutlined,
  accountTree: AccountTreeOutlined,
  website: Language,
  skipNext: SkipNext,
  skipPrevious: SkipPrevious,
  fastForward: FastForward,
  fastRewind: FastRewind,
  restore: YoutubeSearchedForOutlined,
  sync: Sync,
  bundle: Sync,
  contactMailOutlined: ContactMailOutlined,
  pin: PushPinOutlined,
  reset: SettingsBackupRestoreRounded,
  remove: Remove,
  electricity: ElectricBolt,
  tv: Tv,
  internet: Wifi,
  security: Security,
  fire: LocalFireDepartmentOutlined,
  comment: Comment,
  commentOutlined: CommentOutlined,
  zoomInMap: ZoomInMap,
  zoomOutMap: ZoomOutMap,
  search: SearchOutlined,
  disclosure: HeadsetMicOutlined,
  electricMeter: ElectricMeterOutlined,
  cleaning: CleaningServices,
  'washer & dryer': LocalLaundryServiceOutlined,
  'sync-alt': SyncAlt,
  callMade: CallMade,
  callReceived: CallReceived,
  chatOutlined: ChatOutlined,
  phoneCallbackOutlined: PhoneCallbackOutlined,
  forwardToInboxOutlined: ForwardToInboxOutlined,
  creditCard: CreditCard,
  creditScore: CreditScore,
  tag: Tag,
  fileOpen: FileOpenOutlined,
  tuneOutlined: TuneOutlined,
  clear: Clear,
  rotateLeft: RotateLeft,
  copy: ContentCopy,
  gas: LocalFireDepartment,
  water: WaterDrop,
  refresh: RefreshOutlined,
  viewColumn: ViewColumn,
  visibility: Visibility,
  visibilityOff: VisibilityOff,
  close: Close,
  warning: WarningAmberOutlined,
  activityEdit: EditOutlined,
  thumbUp: ThumbUp,
  requestQuote: RequestQuoteOutlined,
  electricalServices: ElectricalServicesOutlined,
  holiday: HolidayVillageOutlined,
  replay: ReplayOutlined,
  timer: TimerOutlined,
  supportAgent: SupportAgentOutlined,
  help: HelpOutlineOutlined,
  success: DoneOutlined,
  play: PlayArrow,
  error: ErrorOutline,
  download: DownloadingOutlined,
};

const CustomIcon = ({
  name = 'user',
  onClick,
  pointer = false,
  fontSize = 'medium',
  tooltip = undefined,
  color = 'inherit',
  classname,
  rounded = false,
  tooltipOptions = {},
  sx = {},
}: Props) => {
  const SelectedIcon = allIcons[name] ?? allIcons['user'];

  return (
    <Icon
      onClick={onClick}
      data-testid={name}
      sx={{
        cursor: pointer ? 'pointer' : 'default',
        display: 'flex',
        overflow: 'visible',
        height: 'auto',
        width: 'auto',
        color: color,
        borderRadius: rounded ? '50%' : '0',
        ...sx,
      }}
      className={classname}
    >
      {tooltip ? (
        <Tooltip {...tooltipOptions} title={tooltip}>
          <SelectedIcon fontSize={fontSize} />
        </Tooltip>
      ) : (
        <SelectedIcon fontSize={fontSize} />
      )}
    </Icon>
  );
};

export default memo(CustomIcon);
